import { render } from "./ProjectsTable.vue?vue&type=template&id=08aea956&scoped=true"
import script from "./ProjectsTable.vue?vue&type=script&lang=js"
export * from "./ProjectsTable.vue?vue&type=script&lang=js"

import "./ProjectsTable.vue?vue&type=style&index=0&id=08aea956&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08aea956"]])

export default __exports__